import React from 'react';
import {useState,useEffect,Component} from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter as Router,Routes,Route,Link} from 'react-router-dom';

import '../Resources/dashboard.css';
import axios from '../../axios.js';
import moment from 'moment/moment';
import Sidebar from './sidebar.js';
import Navbar from './navbar.js';

function Newcrm_managelead(){



  
   //Checking Sessions
 // Access value associated with the login status
 const logstatus=sessionStorage.getItem("logStatus00");
 const logtype=sessionStorage.getItem("logType00");
 const logid=sessionStorage.getItem("logId00");
 const token=sessionStorage.getItem("logToken00");
 const editId=sessionStorage.getItem("EditId00");
 const counterid=sessionStorage.getItem("CounterId00");


 //Checking if Sessions are Set

// alert(logstatus,loguser,logadminid);
 //Sessions Not Set
 {/* if(((logstatus==null)||(logstatus==""))||((logid==null)||(logid==""))||((token==null)||(token==" "))||((busyid==null)||(busyid==" "))||((counterid==null)||(counterid==" "))){
  
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("BusyId00");
   sessionStorage.removeItem("BusyName00");
   sessionStorage.removeItem("CounterId00");
   
 
    window.location.replace("/businesstools-login");
   }
  
   //Sessions Set
   else{

   */}

    
      
//Variables
const[Tbanks,setTbanks] = useState([]);//SetData Variable
const[customers,setcustomers] = useState([],);//SetData Variable
const[cdefault,setcdefault] = useState(0);

//Error Variable
const[errorvar,seterrorvar] = useState();

//customers_count
const[customers_count,setcustomers_count] = useState(1);
//csuccess
//const[ccsuccess,setccsuccess] = useState(0);
//date



//customer_name
const[customer_name,setcustomer_name]=useState();const updatecustomer_name = (event) => { setcustomer_name(event.target.value);}; const[customer_name_er,setcustomer_name_er]=useState();
//contact
const[contact,setcontact]=useState();const updatecontact = (event) => { setcontact(event.target.value);}; const[contact_er,setcontact_er]=useState();
//whatsapp
const[whatsapp,setwhatsapp]=useState();const updatewhatsapp = (event) => { setwhatsapp(event.target.value);}; const[whatsapp_er,setwhatsapp_er]=useState();
//address
const[address,setaddress]=useState();const updateaddress = (event) => { setaddress(event.target.value);}; const[address_er,setaddress_er]=useState();
//city
const[city,setcity]=useState();const updatecity = (event) => { setcity(event.target.value);}; const[city_er,setcity_er]=useState();
//state
const[state,setstate]=useState();const updatestate = (event) => { setstate(event.target.value);}; const[state_er,setstate_er]=useState();
//country
const[country,setcountry]=useState();const updatecountry = (event) => { setcountry(event.target.value);}; const[country_er,setcountry_er]=useState();
//pincode
const[pincode,setpincode]=useState();const updatepincode = (event) => { setpincode(event.target.value);}; const[pincode_er,setpincode_er]=useState();
//email
const[email,setemail]=useState();const updateemail = (event) => { setemail(event.target.value);}; const[email_er,setemail_er]=useState();
//loan_requirement
const[loan_requirement,setloan_requirement]=useState();const updateloan_requirement = (event) => { setloan_requirement(event.target.value);}; const[loan_requirement_er,setloan_requirement_er]=useState();
//loan_amount
const[loan_amount,setloan_amount]=useState();const updateloan_amount = (event) => { setloan_amount(event.target.value);}; const[loan_amount_er,setloan_amount_er]=useState();
//sanction_amount
const[sanction_amount,setsanction_amount]=useState();const updatesanction_amount = (event) => { setsanction_amount(event.target.value);}; const[sanction_amount_er,setsanction_amount_er]=useState();
//cibil_score
const[cibil_score,setcibil_score]=useState();const updatecibil_score = (event) => { setcibil_score(event.target.value);}; const[cibil_score_er,setcibil_score_er]=useState();
//active_loans
const[active_loans,setactive_loans]=useState();const updateactive_loans = (event) => { setactive_loans(event.target.value);}; const[active_loans_er,setactive_loans_er]=useState();
//last_loan_date
const[last_loan_date,setlast_loan_date]=useState();const updatelast_loan_date = (event) => { setlast_loan_date(event.target.value);}; const[last_loan_date_er,setlast_loan_date_er]=useState();
//last_loan_duration_indays
const[last_loan_duration_indays,setlast_loan_duration_indays]=useState();const updatelast_loan_duration_indays = (event) => { setlast_loan_duration_indays(event.target.value);}; const[last_loan_duration_indays_er,setlast_loan_duration_indays_er]=useState();
//lead_stage
const[lead_stage,setlead_stage]=useState();const updatelead_stage = (event) => { setlead_stage(event.target.value);}; const[lead_stage_er,setlead_stage_er]=useState();
//lead_status
const[lead_status,setlead_status]=useState();const updatelead_status = (event) => { setlead_status(event.target.value);}; const[lead_status_er,setlead_status_er]=useState();
//type
const[type,settype]=useState();const updatetype = (event) => { settype(event.target.value);}; const[type_er,settype_er]=useState();
//lead_type
const[lead_type,setlead_type]=useState();const updatelead_type = (event) => { setlead_type(event.target.value);}; const[lead_type_er,setlead_type_er]=useState();
//customer_type
const[customer_type,setcustomer_type]=useState();const updatecustomer_type = (event) => { setcustomer_type(event.target.value);}; const[customer_type_er,setcustomer_type_er]=useState();
//customer_status
const[customer_status,setcustomer_status]=useState();const updatecustomer_status = (event) => { setcustomer_status(event.target.value);}; const[customer_status_er,setcustomer_status_er]=useState();
//amount
const[amount,setamount]=useState();const updateamount = (event) => { setamount(event.target.value);}; const[amount_er,setamount_er]=useState();
//share_per
const[share_per,setshare_per]=useState();const updateshare_per = (event) => { setshare_per(event.target.value);}; const[share_per_er,setshare_per_er]=useState();
//share_amount
const[share_amount,setshare_amount]=useState();const updateshare_amount = (event) => { setshare_amount(event.target.value);}; const[share_amount_er,setshare_amount_er]=useState();
//share_status
const[share_status,setshare_status]=useState();const updateshare_status = (event) => { setshare_status(event.target.value);}; const[share_status_er,setshare_status_er]=useState();
//lead_remarks
const[lead_remarks,setlead_remarks]=useState();const updatelead_remarks = (event) => { setlead_remarks(event.target.value);}; const[lead_remarks_er,setlead_remarks_er]=useState();







//ERROR VARIABLES 
const[error_msg,seterror_msg]=useState();




useEffect(()=>{
   
  getData();
  
  },[])
 

  
    
  
//******************* GET BANKS DATA FUNCTION START  ********************//
function getData(){
 

  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))&&((editId!=null)||(editId!=" "))){
 
 
 axios.post("loancrm-get-leadetails-by-id", {
   Log_id:logid,
   Token:token,
  // Busy_id:busyid,
   Edit_id:editId,
   Sn_start :0,
   Sn_end :0,
   Sn_total :0,
   Sn_limit :0,
   Filter_val :0,

 })
 .then((response) => {


  //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");
     sessionStorage.removeItem("EditId00");


     window.location.replace("/");
  }
  //Success Data Fetched
  if(response.data.successvar==1){

   //Setting Data
   setcustomer_name(response.data.customer_name);
   setcontact(response.data.contact);
   setwhatsapp(response.data.whatsapp);
   setemail(response.data.email);
   setaddress(response.data.address);
   setcity(response.data.city);
   setstate(response.data.state);
   setcountry(response.data.country);
   setpincode(response.data.pincode);
   setloan_requirement(response.data.loan_requirement);
   setloan_amount(response.data.loan_amount);
   setsanction_amount(response.data.sanction_amount);
   setcibil_score(response.data.cibil_score);
   setactive_loans(response.data.active_loans);
   setlast_loan_date(response.data.last_loan_date);
   setlast_loan_duration_indays(response.data.last_loan_duration_indays);
   setlead_status(response.data.lead_status);
   setlead_stage(response.data.lead_stage);
   setshare_per(response.data.share_per);
   setshare_amount(response.data.share_amount);
   setshare_status(response.data.share_status);
   setamount(response.data.amount);
   
   //setprogress(response.data.progress);
   //settotal_login_applications(response.data.total_login_applications);
   //setloanapplications_underreview(response.data.loanapplications_underreview);
   //setloan_applications_rejected(response.data.loan_applications_rejected);
   //setloanapplications_approved(response.data.loanapplications_approved);
   settype(response.data.type);
   setlead_type(response.data.lead_type);
   setcustomer_type(response.data.customer_type);
   setcustomer_status(response.data.customer_status);
   setlead_remarks(response.data.lead_remarks);

  }
  //Cannot Fetch Data
  else{
   seterrorvar("Cannot Fetch Data !");
  }
 
 
 });
 
 }
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("BusyId00");
   sessionStorage.removeItem("CounterId00");

   window.location.replace("businesstools-login");
 
  }
 
 }
  
 //******************* GET BANKS DATA FUNCTION END  ********************//



//******************* CREATE NEW LEAD FUNCTION START ********************//
function createnewlead(){

  const leadremarks = document.getElementById("lead_remarks").value
 

  //Setting Error Variables
  setcustomer_name_er(" "); setwhatsapp_er(" "); setcontact_er(" "); setemail_er(" "); setaddress_er(" "); setcity_er(" "); setstate_er(" "); setcountry_er(" "); setpincode_er(" ");
  setloan_requirement_er(" "); setloan_amount_er(" "); setsanction_amount_er(" "); setcibil_score_er(" "); setactive_loans_er(" "); setlast_loan_date_er(" "); setlast_loan_duration_indays_er(" ");
  setlead_stage_er(" "); setlead_status_er(" "); settype_er(" "); setlead_type_er(" "); setcustomer_status_er(" "); setamount_er(" "); setshare_per_er(" "); setshare_amount_er(" "); setshare_status_er(" ");
  setlead_remarks_er(" "); setshare_per_er(" "); setshare_amount_er(" "); setshare_status_er(" "); setamount_er(" ");

//Checking if user loggedin
if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))&&((editId!=null)||(editId!=" "))/*&&((counterid!=null)||(counterid!=" "))*/){
 
 
  axios.post("loancrm-update-lead", {
   Log_id:logid,
   Token:token,
   Whatsapp : whatsapp,
   Email : email,
   Address : address,
   City : city,
   State : state,
   Country : country,
   Pincode : pincode,
   Loan_requirement : loan_requirement,
   Loan_amount : loan_amount,
   Sanction_amount : sanction_amount,
   Cibil_score : cibil_score,
   Active_loans : active_loans,
   Last_loan_date : moment(last_loan_date).format('YYYY-MM-DD'),//moment(last_loan_date, "DD/MM/YYYY").format("YYYY-MM-DD"), // //last_loan_date,
   Last_loan_duration_indays : last_loan_duration_indays,
   Lead_stage : lead_stage,
   Lead_status : lead_status,
   Type : type,
   Lead_type : lead_type,
   Customer_type : customer_type,
   Customer_status : customer_status,
   Amount : amount,
   Share_per : share_per,
   Share_amount : share_amount,
   Share_status : share_status,
   Lead_remarks : leadremarks, // document.getElementById("lead_remarks").value,//lead_remarks,
   Lead_id : editId,
 
 })
 .then((response) => {
  
  //Invalid Entries


  if(response.data.error==103){     seterror_msg(response.data.error_msg);  return; }

  if(response.data.error==111){     seterror_msg(response.data.error_msg); return; }
  
  //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");

     window.location.replace("/");

  }

   //Validation Errors
 if(response.data.validatorerror){

  setwhatsapp_er(response.data.validatorerror.Whatsapp);
  setemail_er(response.data.validatorerror.Email);
  setaddress_er(response.data.validatorerror.Address);
  setcity_er(response.data.validatorerror.City);
  setstate_er(response.data.validatorerror.State);
  setcountry_er(response.data.validatorerror.Country);
  setpincode_er(response.data.validatorerror.Pincode);
  setloan_requirement_er(response.data.validatorerror.Loan_requirement);
  setloan_amount_er(response.data.validatorerror.Loan_amount);
  setsanction_amount_er(response.data.validatorerror.Sanction_amount);
  setcibil_score_er(response.data.validatorerror.Cibil_score);
  setactive_loans_er(response.data.validatorerror.Active_loans);
  setlast_loan_date_er(response.data.validatorerror.Last_loan_date);
  setlast_loan_duration_indays_er(response.data.validatorerror.Last_loan_duration_indays);
  setlead_stage_er(response.data.validatorerror.Lead_stage);
  setlead_status_er(response.data.validatorerror.Lead_status);
  settype_er(response.data.validatorerror.Type);
  setlead_type_er(response.data.validatorerror.Lead_type);
  setcustomer_type_er(response.data.validatorerror.Customer_type);
  setcustomer_status_er(response.data.validatorerror.Customer_status);
  setamount_er(response.data.validatorerror.Amount);
  setshare_per_er(response.data.validatorerror.Share_per);
  setshare_amount_er(response.data.validatorerror.Share_amount);
  setshare_status_er(response.data.validatorerror.Share_status);
  setlead_remarks_er(response.data.validatorerror.Lead_remarks);

  return;

}
//Invalid Entries
if(response.data.error==102){ 
  
  setwhatsapp_er(response.data.whatsapp_er);
  setemail_er(response.data.email_er);
  setaddress_er(response.data.address_er);
  setcity_er(response.data.city_er);
  setstate_er(response.data.state_er);
  setcountry_er(response.data.country_er);
  setpincode_er(response.data.pincode_er);
  setloan_requirement_er(response.data.loan_requirement_er);
  setloan_amount_er(response.data.loan_amount_er);
  setsanction_amount_er(response.data.sanction_amount_er);
  setcibil_score_er(response.data.cibil_score_er);
  setactive_loans_er(response.data.active_loans_er);
  setlast_loan_date_er(response.data.last_loan_date_er);
  setlast_loan_duration_indays_er(response.data.last_loan_duration_indays_er);
  setlead_stage_er(response.data.lead_stage_er);
  setlead_status_er(response.data.lead_status_er);
  settype_er(response.data.type_er);
  setlead_type_er(response.data.lead_type_er);
  setcustomer_type_er(response.data.customer_type_er);
  setcustomer_status_er(response.data.customer_status_er);
  setamount_er(response.data.amount_er);
  setshare_per_er(response.data.share_per_er);
  setshare_amount_er(response.data.share_amt_er);
  setshare_status_er(response.data.share_status_er);
  setlead_remarks_er(response.data.lead_remarks_er);

 
 
  seterror_msg("Cannot Update Lead !");  return; }

   

   //Transaction Entered Successfully
   if(response.data.successvar==1){   document.getElementById("success-card").style.display="block";  }
   //Cannot Add Transaction
   else{  seterror_msg("Cannot Update Lead !!"); }
  

});
}
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("EditId00");

   window.location.replace("/");
 
  }
 
 }
  
 //******************* CREATE SALES FUNCTION END ********************//






return(
    <>


    <html lang="en">
      <head>
        {/*} Required meta tags */}
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        <title>BUSINESS SAMADHAN | Loan CRM</title>
        {/*} plugins:css */}
        <link rel="stylesheet" href="panel/assets/vendors/mdi/css/materialdesignicons.min.css" />
        <link rel="stylesheet" href="panel/assets/vendors/flag-icon-css/css/flag-icon.min.css" />
        <link rel="stylesheet" href="panel/assets/vendors/css/vendor.bundle.base.css" />
        {/*} endinject */}
        {/*} Plugin css for this page */}
        <link rel="stylesheet" href="panel/assets/vendors/jquery-bar-rating/css-stars.css" />
        <link rel="stylesheet" href="panel/assets/vendors/font-awesome/css/font-awesome.min.css" />
        {/*} End plugin css for this page */}
        {/*} inject:css */}
        {/*} endinject */}
        {/*} Layout styles */}
        <link rel="stylesheet" href="panel/assets/css/demo_1/style.css" />
        {/*} End layout styles */}
        <link rel="shortcut icon" href="panel/assets/images/favicon.png" />
      </head>
      <body>
    
    
        <div class="container-scroller">
    
        <Sidebar />
        <div class="container-fluid page-body-wrapper">
    
    
    
    
           <Navbar />
            {/*} partial */}
            <div class="main-panel">
    
              {/* ADD CUSTOMER SUCCESS CARD START */}
              <div class="d-flex justify-content-center">
              <div class="col-md-6 grid-margin stretch-card" style={{position:"fixed",zIndex:"3",marginTop:"4rem",display:"none"}} id="success-card">
                    <div class="card">
                      <div class="card-body">
                        <h4 class="card-title  text-success"> Lead Updated Successfully !!!</h4>
                      
                        <blockquote class="blockquote">
                          <p class="mb-0"> Click the following button to close.</p>
                          <a href="loancrm-customers-list"><button class="mt-3 btn btn-outline-danger">Close</button></a>
                        </blockquote>
                      </div>
                  
                    </div>
                  </div>
                  </div>
                  {/* ADD CUSTOMER SUCCESS CARD END */}
    
               
              
    
              <div class="content-wrapper pb-0">
    
              
                 {/* CREATE TEAM FORM START */}
                        <div class="row">
                            <div class="col-12 grid-margin">
                         


                <div class="card">
               
                  <div class="card-body">
                    <h4 class="card-title">Manage New Lead</h4>
                    <div class="form-sample">
                      <p class="card-description">manage lead from here</p>
                      <code>{error_msg}</code>
                    
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Customer Name</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="01" id="customer_name" value={customer_name} onChange={updatecustomer_name} />
                            <code>{customer_name_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Contact</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="9798789888" id="contact" value={contact} onChange={updatecontact} />
                            <code>{contact_er}</code>
                            </div>
                          </div>
                        </div>                     
                      </div>
                        <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Whatsapp</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="9787888888" id="whatsapp" value={whatsapp} onChange={updatewhatsapp}/>
                              <code>{whatsapp_er}</code>
                           {/*}   <button class="btn btn-light" hidden={firsts_count>0} onClick={addfirst}>Add this as new customer ....</button>
                              <p class="text-success" style={{display:"none"}} id="cst-customer"><b>New Customer Added!</b></p> */}
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Email</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="myemail@gmail.com" id="email" value={email} onChange={updateemail} />
                            <code>{email_er}</code>
                            </div>
                          </div>
                        </div>                     
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Email</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="Sumansonisharma34@gmail.com" id="email" value={email} onChange={updateemail} />
                            <code>{email_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">City</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="Jabalpur" id="city" value={city} onChange={updatecity} />
                            <code>{city_er}</code>
                            </div>
                          </div>
                        </div>                     
                      </div>
                      <div class="form-group">
                        <label for="exampleTextarea1">Address</label>
                        <textarea class="form-control" rows="2"  id="address" value={address} onChange={updateaddress} ></textarea>
                        <code>{address_er}</code>
                      </div>
                        <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">State</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="Madhya Pradesh" id="state" value={state} onChange={updatestate} />
                              <code>{state_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Pincode</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="482001" id="pincode" value={pincode} onChange={updatepincode} />
                              <code>{pincode_er}</code>
                            </div>
                          </div>
                        </div>                     
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Loan Requirement</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="200000" id="loan_requirement" value={loan_requirement} onChange={updateloan_requirement} />
                              <code>{loan_requirement_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Loan Amount</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="50000.00" id="loan_amount" value={loan_amount} onChange={updateloan_amount} />
                              <code>{loan_amount_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Sanction Amount</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="50000.00"  id="sanction_amount" value={sanction_amount} onChange={updatesanction_amount}/>
                              <small class="text-muted" style={{fontSize:"0.7rem", textAlign:"left"}}>only fill this amount when loan is approved and amount sanctioned</small>
                              <code>{sanction_amount_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Cibil Score</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="736" id="cibil_score" value={cibil_score} onChange={updatecibil_score} />
                              <code>{cibil_score_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Active Loans</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="5"  id="active_loans" value={active_loans} onChange={updateactive_loans} />
                              <code>{active_loans_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Last Loan Date</label>
                            <div class="col-sm-9">
                              <input type="date" class="form-control" id="last_loan_date" value={last_loan_date} onChange={updatelast_loan_date} />
                              <small class="text-muted" style={{fontSize:"0.7rem", textAlign:"left"}}>enter (01-01-1970) if no previous loan</small>
                              <code>{last_loan_date_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Last Loan Duration in Days</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="24r"  id="last_loan_duration_indays" value={last_loan_duration_indays} onChange={updatelast_loan_duration_indays}/>
                              <code>{last_loan_duration_indays_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Lead Stage</label>
                            <div class="col-sm-9">
                            <select class="form-control" placeholder="121" id="lead_stage" style={{padding:"1rem"}} value={lead_stage} onChange={updatelead_stage}  >
                            <option value={lead_stage}>{lead_stage}</option>
                              <option value=" ">select lead stage</option>
                              <option value="new enquiry">new enquiry</option>
                              <option value="requested documents">requested documents</option>
                              <option value="documents verification under process">documents verification under process</option>
                              <option value="applied for loan">applied for loan</option>
                              <option value="under review">under review</option>
                              <option value="rejected">rejected</option>
                              <option value="on hold">on hold</option>
                              <option value="approved">approved</option>
                              </select>
                              <code>{lead_stage_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Lead Status</label>
                            <div class="col-sm-9">
                            <select class="form-control" value={lead_status}  style={{padding:"1rem"}} onChange={updatelead_status}  >
                              <option value={lead_status}>{lead_status}</option>
                              <option value=" ">select lead status</option>
                              <option value="active">active</option>
                              <option value="not responding">not responding</option>
                              <option value="closed">closed</option>
                              <option value="poor lead">poor lead</option>
                              </select>
                              <code>{lead_status_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Type</label>
                            <div class="col-sm-9">
                              <select class="form-control" pincode="420110" id="type" value={type} onChange={updatetype} style={{padding:"1rem"}}>
                              <option value={type}>{type}</option>
                              <option value=" ">select type</option>
                              <option value="very good">very good</option>
                              <option value="good">good</option>
                              <option value="average">average</option>
                              <option value="poor">poor</option>
                              <option value="very poor">very poor</option>
                              </select>
                              <code>{type_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Lead Type</label>
                            <div class="col-sm-9">
                              <select class="form-control" placeholder="India"  id="lead_type" value={lead_type} onChange={updatelead_type} style={{padding:"1rem"}}>
                              <option value={lead_type}>{lead_type}</option>
                              <option value=" ">select lead type</option>
                              <option value="business loan">business loan</option>
                              <option value="personal loan">personal loan</option>
                              <option value="home loan">home loan</option>
                              <option value="other">other</option>
                              </select>
                              <code>{lead_type_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Customer Type</label>
                            <div class="col-sm-9">
                              <select class="form-control" pincode="420110" id="customer_type" value={customer_type} onChange={updatecustomer_type} style={{padding:"1rem"}}>
                              <option value={customer_type}>{customer_type}</option>
                              <option value=" ">select customer type</option>
                              <option value="salaried">salaried</option>
                              <option value="business">business</option>
                              <option value="other">other</option>
                              </select>
                              <code>{customer_type_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                
                      <div class="form-group">
                        <label for="exampleTextarea1">Lead Remarks</label>
                        <textarea  class="form-control" rows="2" id="lead_remarks" value={lead_remarks} onChange={updatelead_remarks} >
                        </textarea>
                        <code>{lead_remarks_er}</code>
                      </div>

                      <hr/>
                      <h4 style={{textAlign:"left"}}>Payout Details</h4>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Amount</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="50000.00"  id="amount" value={amount} onChange={updateamount}/>
                              <small class="text-muted" style={{fontSize:"0.7rem", textAlign:"left"}}>only fill this amount when loan is approved and amount sanctioned</small>
                              <code>{amount_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">PayOut Status</label>
                            <div class="col-sm-9">
                              <select class="form-control" placeholder="736" id="share_status" value={share_status} style={{padding:"1rem"}} onChange={updateshare_status} >
                              <option value={share_status}>{share_status}</option>
                              <option value=" ">select payout status</option>
                              <option value="applicable">applicable</option>
                              <option value="not applicable">not applicable</option>
                              <option value="under process">under process</option>
                              <option value="approved">approved</option>
                              <option value="transferred">transferred</option>
                              </select>
                              <small class="text-muted" style={{fontSize:"0.7rem", textAlign:"left"}}>only fill this amount when loan is approved and amount sanctioned</small>
                              <code>{share_status_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">PayOut %</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="5.00"  id="share_per" value={share_per} onChange={updateshare_per}/>
                              <small class="text-muted" style={{fontSize:"0.7rem", textAlign:"left"}}>only fill this amount when loan is approved and amount sanctioned</small>
                              <code>{share_per_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">PayOut Amount</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" pincode="10000" id="share_amount" value={share_amount} onChange={updateshare_amount} />
                              <small class="text-muted" style={{fontSize:"0.7rem", textAlign:"left"}}>only fill this amount when loan is approved and amount sanctioned</small>
                              <code>{share_amount_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                    
                        
                      
                        <button class="btn btn-primary" style={{fontWeight:"bold"}} onClick={createnewlead}>Update Lead</button>
                      
                       
    
                     
                   
                    </div>
                  </div>
                </div>
                 {/* CREATE TEAM FORM END */}

                        
                        </div>
                    </div>
                 
                   
            
          </div>
          {/*} content-wrapper ends */}
          {/*} partial:partials/_footer.html */}
        {/*}  <footer class="footer">
            <div class="d-sm-flex justify-content-center justify-content-sm-between">
              <span class="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © 2021 <a href="https://www.bootstrapdash.com/" target="_blank">BootstrapDash</a>. All rights reserved.</span>
              <span class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Hand-crafted & made with <i class="mdi mdi-heart text-danger"></i></span>
            </div>
          </footer> */}
          {/*} partial */}
        </div>
        {/*} main-panel ends */}
      </div>
      {/*} page-body-wrapper ends */}
    </div>
    {/*} container-scroller */}
    {/*} plugins:js */}
    <script src="panel/assets/vendors/js/vendor.bundle.base.js"></script>
    {/*} endinject */}
    {/*} Plugin js for this page */}
    <script src="panel/assets/vendors/jquery-bar-rating/jquery.barrating.min.js"></script>
    <script src="panel/assets/vendors/chart.js/Chart.min.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.resize.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.categories.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.fillbetween.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.stack.js"></script>
    <script src="panel/assets/js/jquery.cookie.js" type="text/javascript"></script>
    {/*} End plugin js for this page */}
    {/*} inject:js */}
    <script src="panel/assets/js/off-canvas.js"></script>
    <script src="panel/assets/js/hoverable-collapse.js"></script>
    <script src="panel/assets/js/misc.js"></script>
    <script src="panel/assets/js/settings.js"></script>
    <script src="panel/assets/js/todolist.js"></script>
    {/*} endinject */}
    {/*} Custom js for this page */}
    <script src="panel/assets/js/dashboard.js"></script>
    {/*} End custom js for this page */}
  </body>
</html>
    </>

);

}
//}

export default Newcrm_managelead;